import React from "react";
import { generatePublicUrl } from "../../urlConfig";

const MailingRenderProductItems = ({
    productArray = [],
    mainImage = [],
    contact = []
}) => {
    const contactItem = Array.isArray(contact) && contact.length ? contact[0] : {};
    const mainImageItem = Array.isArray(mainImage) && mainImage.length ? mainImage[0] : {};

    const mobileNumber = contactItem.number || "";
    const email = contactItem.email || "support@alotb.ru";
    const logoSrc = mainImageItem.image ? generatePublicUrl(mainImageItem.image) : "";

    return (
        <div
            style={{
                width: "100%",
                background: "#ececec",
                padding: "20px",
            }}
        >
            <div
                style={{
                    fontFamily: "Arial, sans-serif",
                    background: "#ffffff",
                    borderRadius: "8px",
                    textAlign: "center",
                    padding: "20px",
                    maxWidth: "600px",
                    margin: "0 auto",
                    border: "1px solid #e5e7eb"
                }}
            >
                <div style={{ marginBottom: "20px" }}>
                    {logoSrc && (
                        <div
                            style={{
                                width: "50%",
                                display: "inline-block",
                                textAlign: "left",
                                verticalAlign: "middle"
                            }}
                        >
                            <img
                                style={{
                                    width: "120px",
                                    height: "120px",
                                    objectFit: "contain"
                                }}
                                src={logoSrc}
                                alt="ALOTB"
                            />
                        </div>
                    )}

                    <div
                        style={{
                            width: logoSrc ? "50%" : "100%",
                            display: "inline-block",
                            textAlign: logoSrc ? "right" : "center",
                            verticalAlign: "middle"
                        }}
                    >
                        <a
                            href="https://alotb.ru"
                            style={{
                                color: "#2563eb",
                                textDecoration: "none",
                                fontSize: "15px",
                                fontWeight: "bold"
                            }}
                        >
                            Перейти на наш сайт
                        </a>
                    </div>
                </div>

                <h2
                    style={{
                        color: "#111827",
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginBottom: "10px"
                    }}
                >
                    Здравствуйте, представляем вам наш каталог!
                </h2>

                <p
                    style={{
                        color: "#4b5563",
                        fontSize: "16px",
                        marginBottom: "20px",
                        lineHeight: "1.5"
                    }}
                >
                    Мы подготовили для вас подборку изделий. Подробную информацию можно посмотреть на сайте.
                </p>

                <div style={{ textAlign: "center" }}>
                    {productArray && productArray.length > 0 ? (
                        productArray.map((item) => {
                            const product = item.productId || {};
                            const productId = product._id || product.id;
                            const productName = product.fullName || product.name || "Товар";
                            const imageSrc = item.reducedImage ? generatePublicUrl(item.reducedImage) : "";

                            return (
                                <div
                                    key={productId || productName}
                                    style={{
                                        display: "inline-block",
                                        maxWidth: "260px",
                                        minWidth: "230px",
                                        margin: "10px",
                                        verticalAlign: "top",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "8px",
                                        padding: "12px",
                                        background: "#ffffff"
                                    }}
                                >
                                    {imageSrc && (
                                        <div style={{ marginBottom: "10px" }}>
                                            <img
                                                style={{
                                                    height: "120px",
                                                    maxWidth: "100%",
                                                    width: "auto",
                                                    borderRadius: "6px",
                                                    objectFit: "contain"
                                                }}
                                                src={imageSrc}
                                                alt={productName}
                                            />
                                        </div>
                                    )}

                                    <div
                                        style={{
                                            color: "#111827",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            textDecoration: "none",
                                            marginBottom: "14px",
                                            lineHeight: "1.35"
                                        }}
                                    >
                                        {productName}
                                    </div>

                                    {productId && (
                                        <a
                                            style={{
                                                display: "inline-block",
                                                background: "#349a87",
                                                color: "#ffffff",
                                                padding: "10px 20px",
                                                fontSize: "15px",
                                                borderRadius: "6px",
                                                textDecoration: "none",
                                                fontWeight: "bold"
                                            }}
                                            href={`https://alotb.ru/productDetails/${productId}`}
                                        >
                                            Подробнее
                                        </a>
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <p
                            style={{
                                color: "#6b7280",
                                fontSize: "15px"
                            }}
                        >
                            Товары для письма не выбраны.
                        </p>
                    )}
                </div>

                <p
                    style={{
                        color: "#4b5563",
                        fontSize: "16px",
                        marginTop: "22px",
                        lineHeight: "1.5"
                    }}
                >
                    Полный каталог изделий можно посмотреть на нашем сайте.
                </p>

                <a
                    style={{
                        display: "inline-block",
                        background: "#349a87",
                        color: "#ffffff",
                        padding: "10px 22px",
                        fontSize: "16px",
                        borderRadius: "6px",
                        textDecoration: "none",
                        fontWeight: "bold",
                        marginTop: "4px"
                    }}
                    href="https://alotb.ru"
                >
                    Перейти на сайт
                </a>

                <div
                    style={{
                        marginTop: "30px",
                        textAlign: "left",
                        borderTop: "1px solid #e5e7eb",
                        paddingTop: "18px"
                    }}
                >
                    <p
                        style={{
                            color: "#6b7280",
                            fontSize: "14px",
                            margin: "0 0 8px"
                        }}
                    >
                        Связаться с нами:
                    </p>

                    {mobileNumber && (
                        <p
                            style={{
                                color: "#111827",
                                fontSize: "14px",
                                margin: "0 0 8px"
                            }}
                        >
                            Телефон:{" "}
                            <a
                                href={`tel:${mobileNumber}`}
                                style={{
                                    color: "#2563eb",
                                    textDecoration: "none"
                                }}
                            >
                                {mobileNumber}
                            </a>
                        </p>
                    )}

                    <p
                        style={{
                            color: "#111827",
                            fontSize: "14px",
                            margin: "0"
                        }}
                    >
                        Почта:{" "}
                        <a
                            href={`mailto:${email}`}
                            style={{
                                color: "#2563eb",
                                textDecoration: "none"
                            }}
                        >
                            {email}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MailingRenderProductItems;